import Enum from "../../../../../../enums/Enum";

const TimingEnum = new Enum({
    MORNING: {name: "Morning", nameInArabic: "الصباح"},
    EVENING: {name: "Evening", nameInArabic: "المساء"},
    DAYTIME: {name: "Daytime", nameInArabic: "النهار"},
    MOVEMENTSPECIFIC: {name: "Movement Specific", nameInArabic: "القيام بحركة محددة"}
});

export default TimingEnum;